module.exports = __webpack_public_path__ + "static/media/no-matches -yet.3359ef78.svg";